import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Checkbox, Form } from 'semantic-ui-react';

import { getUri, isEnabled } from '../../helpers/preCheck';
import InlineError from '../Messages/InlineError';

const preCheckRowStyle = {
  minHeight: '5em',
};

//preCheckData is an object with the following shape: { preCheck: preCheck }
export default function PreCheckSetup({
  onPreCheckDataChange,
  preCheckData,
  uriDefault = 'https://forms.wonderschool.com/health-check/',
  errors = null,
}) {
  const { t } = useTranslation();

  const { preCheck } = preCheckData;
  const isPreCheckEnabled = isEnabled(preCheckData);
  const uri = getUri(preCheckData);

  const onUriChange = (e, { value }) => {
    onPreCheckDataChange({
      preCheck: {
        ...preCheck,
        uri: value,
      },
    });
  };

  const onPreCheckEnabledChange = (_e, { checked }) => {
    onPreCheckDataChange({
      preCheck: {
        ...preCheck,
        enabled: checked,
      },
    });
  };

  return (
    <>
      <Form.Radio
        toggle
        id="preCheckEnabled"
        name="preCheckEnabled"
        label={t('admin.preCheck.enableLabel')}
        checked={isPreCheckEnabled}
        onChange={onPreCheckEnabledChange}
        control={Checkbox}
      />
      {isPreCheckEnabled && (
        <Form.Group widths="equal" style={preCheckRowStyle}>
          {uriDefault && (
            <Form.Field error={!!errors?.uri}>
              <Form.Input
                type="text"
                id="uri"
                name="uri"
                value={uri}
                onChange={onUriChange}
                label={t('admin.preCheck.formUrlLabel')}
                placeholder={uriDefault}
              />
              {errors?.uri && <InlineError text={errors.uri} />}
            </Form.Field>
          )}
        </Form.Group>
      )}
    </>
  );
}
